const updates = [
  {
    date: '2026-07-30',
    tag: '新剧上线',
    title: '《暗夜追踪》第二季全集上线西瓜视频免费专区',
    desc: '悬疑犯罪题材口碑佳作回归，全12集高清不缓冲在线观看，首播当日点击量突破500万。',
    tagColor: 'primary',
  },
  {
    date: '2026-07-29',
    tag: '片库更新',
    title: '暑期档电影大全新增30部好莱坞经典大片',
    desc: '涵盖科幻、动作、喜剧等多种类型，高清画质丝瓜视频同步上线，暑期观影指南已整理。',
    tagColor: 'accent',
  },
  {
    date: '2026-07-28',
    tag: '番剧追更',
    title: '热门国漫《仙道至尊》第48话更新 丝瓜视频独家放送',
    desc: '人气修仙题材国漫持续热播中，每周三、周六更新，已累积追番用户超80万。',
    tagColor: 'secondary',
  },
  {
    date: '2026-07-27',
    tag: '综艺上线',
    title: '《欢乐喜剧人》新一季西瓜视频免费全集上架',
    desc: '国内顶级喜剧竞演节目回归，多位喜剧大咖加盟，笑点密集全程高能不容错过。',
    tagColor: 'primary',
  },
  {
    date: '2026-07-26',
    tag: '纪录片',
    title: 'BBC最新自然纪录片《蓝色星球III》高清上线',
    desc: '历时四年拍摄的海洋生态巨制，全7集西瓜视频高清在线观看，豆瓣评分高达9.5。',
    tagColor: 'accent',
  },
  {
    date: '2026-07-25',
    tag: '专区推荐',
    title: '「经典港片回顾」专题上线 百部粤语原声高清合集',
    desc: '从80年代到千禧年经典港片一次收录，丝瓜视频与西瓜视频双平台同步播放。',
    tagColor: 'secondary',
  },
  {
    date: '2026-07-24',
    tag: '平台公告',
    title: '黑桃视频播放器全面升级 支持4K超清不缓冲播放',
    desc: '全新播放引擎上线，画质提升至4K分辨率，智能带宽适配技术确保流畅观影体验。',
    tagColor: 'primary',
  },
];

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            影视资源每日更新，不错过任何一部好片
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          {updates.map((item, i) => (
            <div key={i} className="flex gap-4 md:gap-6 group">
              <div className="flex flex-col items-center shrink-0">
                <div className="w-3 h-3 rounded-full bg-primary-500 mt-1.5 group-hover:scale-125 transition-transform duration-200"></div>
                {i < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 my-1"></div>
                )}
              </div>
              <div className={`pb-8 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="flex flex-wrap items-center gap-3 mb-2">
                  <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${tagColorMap[item.tagColor]}`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="text-base font-medium text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}